module.exports = __webpack_public_path__ + "videos/mts-products-chats-in-platform.639433b.mp4";